import ControlInput from 'lqa-ui/lib/Components/ControlInput';
import ControlSelect from 'lqa-ui/lib/Components/ControlSelect';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { USER_LEVEL } from '../../utils/constants';
import ControlTextarea from 'lqa-ui/lib/Components/ControlTextarea';
import { FormContainer, InputContainer, InputText } from './EditCV.styled';
import { Headline3 } from './../../app/common/typography';

const Input = ({ onChange, label, name, value, errors, ...otherProps }) => {
  return (
    <ControlInput
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      required={true}
      hasError={errors && !!errors[name]}
      {...otherProps}
    />
  );
};

const CVForm = ({
  isFormEditable = true,
  formTitle = 'Current Hotel CV Setup',
  values,
  errors,
  handleChange,
  setErrors,
  index,
  setValues,
  showFormTitle = true,
  departmentList,
  isCurrentHotel,
  hotelName,
  allHotelData,
}) => {
  const [value, setValue] = useState(values[index]);
  const [errorObject, setErrorObject] = useState<any>({});

  useEffect(() => {
    if (
      errors[isCurrentHotel ? 'currentHotel' : 'previousHotel'] &&
      errors[isCurrentHotel ? 'currentHotel' : 'previousHotel'][hotelName] &&
      errors[isCurrentHotel ? 'currentHotel' : 'previousHotel'][hotelName][
        index
      ]
    ) {
      setErrorObject(
        errors[isCurrentHotel ? 'currentHotel' : 'previousHotel'][hotelName][
          index
        ]
      );
    } else {
      setErrorObject({});
    }
  }, [errors]);

  useEffect(() => {
    setValue(values[index]);
  }, [values]);
  return (
    <div className="cv-form-container">
      <FormContainer>
        {showFormTitle && <Headline3>{formTitle}</Headline3>}
        {departmentList && !!departmentList.length && (
          <InputContainer>
            <InputText hasValue={value.department}>Department</InputText>
            <ControlSelect
              disableSearch={true}
              onChange={(e) => {
                const newErrors: any = [...errors];
                const hotelIdentifier = value.isCurrentHotel
                  ? 'currentHotel'
                  : 'previousHotel';
                if (!e.target.value) {
                  newErrors[hotelIdentifier] = newErrors[hotelIdentifier] || {};
                  newErrors[hotelIdentifier][hotelName] =
                    newErrors[hotelIdentifier][hotelName] || [];
                  newErrors[hotelIdentifier][hotelName][index] =
                    newErrors[hotelIdentifier][hotelName][index] || {};
                  newErrors[isCurrentHotel ? 'currentHotel' : 'previousHotel'][
                    hotelName
                  ][index].department = `${'Department'} is required`;
                } else {
                  if (
                    newErrors[hotelIdentifier] &&
                    newErrors[hotelIdentifier][hotelName] &&
                    newErrors[hotelIdentifier][hotelName][index]
                  ) {
                    delete newErrors[hotelIdentifier][hotelName][index]
                      .department;
                  }
                }
                setErrors(newErrors);
                const newCvInputValues = { ...allHotelData };
                newCvInputValues[
                  isCurrentHotel ? 'currentHotel' : 'previousHotel'
                ][hotelName][index].department = e.target.value;
                setValues(newCvInputValues);
              }}
              value={value.department}
              className={`cv-select ${
                errorObject.department ? 'hasError' : ''
              }`}
            >
              <option />
              <option key="All" value="All">
                All
              </option>
              {departmentList.map((department) => {
                return (
                  <option key={department.id} value={department.value}>
                    {department.value}
                  </option>
                );
              })}
            </ControlSelect>
          </InputContainer>
        )}
        <Input
          label="Job Title"
          name="currentJobTitle"
          value={value.currentJobTitle}
          onChange={(e) => handleChange(e, isCurrentHotel, hotelName, index)}
          errors={errorObject}
          disabled={!isFormEditable}
        />
        <InputContainer>
          <InputText hasValue={value.level}>Job Level</InputText>
          <ControlSelect
            disableSearch={true}
            onChange={(e) => {
              const newErrors: any = [...errors];
              const hotelIdentifier = value.isCurrentHotel
                ? 'currentHotel'
                : 'previousHotel';
              if (!e.target.value) {
                newErrors[hotelIdentifier] = newErrors[hotelIdentifier] || {};
                newErrors[hotelIdentifier][hotelName] =
                  newErrors[hotelIdentifier][hotelName] || [];
                newErrors[hotelIdentifier][hotelName][index] =
                  newErrors[hotelIdentifier][hotelName][index] || {};
                newErrors[isCurrentHotel ? 'currentHotel' : 'previousHotel'][
                  hotelName
                ][index].level = `${'level'} is required`;
              } else {
                if (
                  newErrors[hotelIdentifier] &&
                  newErrors[hotelIdentifier][hotelName] &&
                  newErrors[hotelIdentifier][hotelName][index]
                ) {
                  delete newErrors[hotelIdentifier][hotelName][index].level;
                }
              }
              setErrors(newErrors);
              const newCvInputValues = { ...allHotelData };
              newCvInputValues[
                isCurrentHotel ? 'currentHotel' : 'previousHotel'
              ][hotelName][index].level = e.target.value;
              setValues(newCvInputValues);
            }}
            value={value.level}
            className={`cv-select ${errorObject.level ? 'hasError' : ''}`}
          >
            <option />
            {Object.entries(USER_LEVEL).map(([key, value], index) => {
              return (
                <option key={index} value={key}>
                  {value}
                </option>
              );
            })}
          </ControlSelect>
        </InputContainer>
        <div
          className={`formDiv inpDate ${
            errorObject.startDate ? 'hasError' : ''
          }`}
        >
          <label className={`${value.startDate ? 'hasValue' : ''}`}>
            Start Date
          </label>
          <DatePicker
            name="startDate"
            popperClassName="date-picker-popper"
            selected={value.startDate ? new Date(value.startDate) : ''}
            onFocus={(e) => e.target.blur()}
            onKeyDown={(e) => {
              if (isNaN(e.target.value) || e.target.value !== '/') {
                e.preventDefault();
              }
            }}
            maxDate={new Date()}
            onChange={(selectedDate) => {
              const newCvInputValues = { ...allHotelData };
              newCvInputValues[
                isCurrentHotel ? 'currentHotel' : 'previousHotel'
              ][hotelName][index].startDate = selectedDate;
              const newErrors: any = [...errors];
              const hotelIdentifier = value.isCurrentHotel
                ? 'currentHotel'
                : 'previousHotel';
              if (selectedDate) {
                if (
                  newErrors[hotelIdentifier] &&
                  newErrors[hotelIdentifier][hotelName] &&
                  newErrors[hotelIdentifier][hotelName][index]
                ) {
                  delete newErrors[hotelIdentifier][hotelName][index].startDate;
                }

                // if endDate is greater than start Date, reset end date
                if (value.endDate && selectedDate > value.endDate) {
                  newCvInputValues[
                    isCurrentHotel ? 'currentHotel' : 'previousHotel'
                  ][hotelName][index].endDate = null;
                }
              } else {
                newErrors[hotelIdentifier] = newErrors[hotelIdentifier] || {};
                newErrors[hotelIdentifier][hotelName] =
                  newErrors[hotelIdentifier][hotelName] || [];
                newErrors[hotelIdentifier][hotelName][index] =
                  newErrors[hotelIdentifier][hotelName][index] || {};
                newErrors[isCurrentHotel ? 'currentHotel' : 'previousHotel'][
                  hotelName
                ][index].endDate = `${'endDate'} is required`;
              }
              setErrors(newErrors);
              setValues(newCvInputValues);
            }}
            showMonthDropdown={true}
            showYearDropdown={true}
            scrollableYearDropdown={true}
            scrollableMonthYearDropdown={true}
            yearDropdownItemNumber={100}
          />
        </div>
        {!value.isActivePosition && (
          <div
            className={`formDiv inpDate ${
              errorObject.endDate ? 'hasError' : ''
            }`}
          >
            <label className={`${value.endDate ? 'hasValue' : ''}`}>
              End Date
            </label>
            <DatePicker
              name="endDate"
              popperClassName="date-picker-popper"
              selected={value.endDate ? new Date(value.endDate) : ''}
              onFocus={(e) => e.target.blur()}
              onKeyDown={(e) => {
                if (isNaN(e.target.value) || e.target.value !== '/') {
                  e.preventDefault();
                }
              }}
              minDate={value.startDate}
              maxDate={new Date()}
              onChange={(selectedDate) => {
                const newCvInputValues = { ...allHotelData };
                newCvInputValues[
                  isCurrentHotel ? 'currentHotel' : 'previousHotel'
                ][hotelName][index].endDate = selectedDate;
                setValues(newCvInputValues);
                const newErrors: any = [...errors];
                const hotelIdentifier = value.isCurrentHotel
                  ? 'currentHotel'
                  : 'previousHotel';

                if (selectedDate) {
                  if (
                    newErrors[hotelIdentifier] &&
                    newErrors[hotelIdentifier][hotelName] &&
                    newErrors[hotelIdentifier][hotelName][index]
                  ) {
                    delete newErrors[hotelIdentifier][hotelName][index].endDate;
                  }
                } else {
                  newErrors[hotelIdentifier] = newErrors[hotelIdentifier] || {};
                  newErrors[hotelIdentifier][hotelName] =
                    newErrors[hotelIdentifier][hotelName] || [];
                  newErrors[hotelIdentifier][hotelName][index] =
                    newErrors[hotelIdentifier][hotelName][index] || {};
                  newErrors[isCurrentHotel ? 'currentHotel' : 'previousHotel'][
                    hotelName
                  ][index].endDate = `${'endDate'} is required`;
                }
                setErrors(newErrors);
              }}
              showMonthDropdown={true}
              showYearDropdown={true}
              scrollableYearDropdown={true}
              scrollableMonthYearDropdown={true}
              yearDropdownItemNumber={100}
            />
          </div>
        )}

        <div className="floating-wrapper">
          <label className={`${value.jobDescription ? 'hasValue' : ''}`}>
            Job Responsibilities
          </label>
          <ControlTextarea
            minRows={2}
            className={`${
              errorObject && errorObject.jobDescription ? 'has-error' : ''
            }`}
            name="jobDescription"
            value={value.jobDescription}
            onChange={(e) => handleChange(e, isCurrentHotel, hotelName, index)}
            disabled={!isFormEditable}
          />
        </div>
      </FormContainer>
    </div>
  );
};

export default CVForm;
